<template>
  <v-app>
    <v-content>
      <v-container class="fill-height" fluid>
        <LoginForm />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import LoginForm from '@/components/login/LoginForm.vue';

export default {
  components: {
    LoginForm
  }
};
</script>
